import Config from '../launch/config'
import {deselectAllShips} from '../ship/utils'

const handleInfoClick = ({
    entity,
    ship,
    selectedShipIds,
    setModalContentType,
    toggleGameOverOverlay,
    toggleModal,
    towable,
}) => {
    const cam = Config.scene.cameras.main
    let camTarget
    let modalType

    if (entity) {
        modalType = 'entity'
        camTarget = entity
        entity.deselect()
    }

    if (ship && Object.keys(selectedShipIds).length === 1) {
        modalType = 'ship'
        camTarget = ship
        deselectAllShips()
    }

    if (towable) {
        modalType = 'towable'
        camTarget = towable
        towable.deselect()
    }

    if (camTarget) {
        cam.pan(camTarget.x, camTarget.y, 300, 'Linear', true)
        cam.zoomTo(Config.zoomDefault, Config.zoomDefaultTime)
    }

    toggleGameOverOverlay(false)
    modalType && setModalContentType(modalType)
    toggleModal()
}

export default handleInfoClick
